import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { ACTION_NAVIGATE_TO_STEP } from '../../store/state/actions';
import { getDataContextName } from '../../container/container-utils';
import { getSubmitData, processHeaders, SCOPE_TYPES } from '../../store/state/epics/util';
import { logAndCatchError } from '../../utils/rxjs-utils';
import type { Action } from '../../store/state/state-manager';

const NAVIGATE_TO_STEP_DXAPI_LOG_ERROR_MESSAGE = 'Error occurred during ajax call at navigateToStep Epic : ';

export const executeNavigateToStepRequest = (
  actionInPayload: Action['payload'],
  options: { state$: { value: any } }
) => {
  const {
    ID,
    stepID,
    containerItemID,
    context = getDataContextName(containerItemID),
    isInCreateStage
  } = actionInPayload;
  const { state$ } = options;
  const viewType = isInCreateStage ? SCOPE_TYPES.PAGE : SCOPE_TYPES.FORM;
  const actionPayload = {
    ID,
    stepID,
    viewType
  };
  const { restApi, reqType } = resolveRestApi(ACTION_NAVIGATE_TO_STEP, actionPayload);

  const { content } = getSubmitData(context);
  const reqHeaders = state$.value.data[context].caseInfo.headers;

  return from(
    fetch(
      `${restApi}`,
      {
        method: reqType,
        body: content,
        headers: {
          'if-match': reqHeaders && reqHeaders.etag
        }
      },
      context
    )
  ).pipe(
    map((response) => {
      return {
        response: response.data,
        actionInPayload,
        headers: processHeaders({ ...reqHeaders, ...response.headers })
      };
    }),
    logAndCatchError(NAVIGATE_TO_STEP_DXAPI_LOG_ERROR_MESSAGE, context)
  );
};

export default executeNavigateToStepRequest;
